import React, { Fragment, useContext } from 'react'
import { Flex, Block } from '../../components/basic/layout'
import { H5, H2, P  } from '../../components/basic/text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/fontawesome-free-solid'
import { Gray_150 } from '../../constants/colors'
import { GAContext } from '../../context/googleAnalytics'
import { GaDesignerSubStepComplete, GaDesignerStepComplete, GaDesignerComplete } from '../../data/googleAnalytics'

export const TopStepNavigation = props => {
    const [gaState, gaDispatch] = useContext(GAContext)
    const { state, dispatch, data, callback } = props
    const mobile = state.resize < 1025
    
    //console.log("Top Step Navigation");
    const NavigateToStep = (step, substep) => {
        if(step !== state.step) {
            // If the desired step is before current step, just go to it.
            if(CalculateStepKey(step) < CalculateStepKey(state.step)) {
                dispatch({type: 'SET_STEP', payload: step})
                dispatch({type: 'SET_SUBSTEP', payload: substep})
                // Currently used to close mobile menu after choosing navigation step
                if(callback) {
                    callback()
                }
            } else {
                // If the current step is complete try navigating otherwise throw alert.
                if(CheckCompletedCurrentStep()) {
                    // If all the steps on the way to the destination are complete, navigate.
                    if(CalculateStepsToDestinationComplete(step)) {
                        if(!gaState.exitSubstep.includes(state.substep)) {
                            const currentExitSubsteps = gaState.exitSubstep
                            currentExitSubsteps.push(state.substep)
                            GaDesignerSubStepComplete(state, data)
                            gaDispatch({type: 'SET_EXIT_SUBSTEP', payload: currentExitSubsteps})
                        }
                        if(!gaState.exitStep.includes(state.step)) {
                            const currentExitSteps = gaState.exitStep
                            currentExitSteps.push(state.step)
                            GaDesignerStepComplete(state, data)
                            gaDispatch({type: 'SET_EXIT_STEP', payload: currentExitSteps})
                        }
                        if(step === "Review") {
                            if(!gaState.enterReview) {
                                if (!window.jostensGaTracking) {    // triggered only for legacy GA code
                                    GaDesignerComplete(state, data)
                                }
                                gaDispatch({type: 'SET_ENTER_REVIEW', payload: true})
                            }
                        }
                        dispatch({type: 'SET_STEP', payload: step})
                        dispatch({type: 'SET_SUBSTEP', payload: substep})
                        // Currently used to close mobile menu after choosing navigation step
                        if(callback) {
                            callback()
                        }
                    } else {
                        // alert(`You must complete all steps before the "${step}" step, prior to moving to the "${step}" step.`)
                    }
                } else {
                    // alert("You must complete this step to move onto the next")
                }
            }
        }
    }

    const CalculateStepsToDestinationComplete = step => {
        let destinationStepNumber = CalculateStepKey(step)
        let checkSubstepsTitleArray = []
        let stepsComplete = true
        let choices = Object.values(state.choices)
        for(let i = 0; i < destinationStepNumber; i++) {
            for(let j = 0; j < data.steps[i].substeps.length; j++) {
                checkSubstepsTitleArray.push(data.steps[i].substeps[j].title)
            }
        }
        for(let i = 0; i < choices.length; i++) {
            if(checkSubstepsTitleArray.includes(choices[i].title)) {
                if(!choices[i].completed) {
                    stepsComplete = false
                }
            }
        }
        return stepsComplete
    }

    const CalculateStepKey = step => {
        if(step === "Review") {
            return data.steps.length
        }
        for(let i = 0; i < data.steps.length; i++) {
            if(step === data.steps[i].title) {
                return i
            }
        }
    }

    const CheckCompletedCurrentStep = () => {
        const choicesArray = Object.values(state.choices)
        let complete = choicesArray.every(choice => {
            if(choice.step === state.step) {
                return choice.completed;
            }
            return true
        })
        return complete
    }

    const CheckStepCompletedStatus = step => {
        const choicesArray = Object.values(state.choices)
        let complete = false
        if(choicesArray.length > 0) {
            const stepChoicesArray = []
            for(let i = 0; i < choicesArray.length; i++) {
                if(choicesArray[i].step === step.title) {
                    stepChoicesArray.push(choicesArray[i])
                }
            }
            if(stepChoicesArray.length > 0) {
                complete = stepChoicesArray.every(choice => {
                    if(choice.completed) {
                        return true
                    }
                    return false
                })
            }
        }
        return complete
    }

    return (
        <Block margin={!mobile && "0 0 30px 0"}>
            {mobile
                ? <Fragment>
                    { data && data.steps && data.steps.map((step, key) => {
                        if(CheckStepCompletedStatus(step)) {
                            return <Flex onClick={() => NavigateToStep(step.title, step.substeps[0].title)} borderTop="1px solid lightgray"  background="white" padding="10px" justify="space-between" key={`Package-step-icon-${key + 1}`}>
                                <H5 size="14px"  weight="bold">
                                    {step.title}
                                </H5>
                                <Block margin="0"
                                    cursor="pointer"
                                    height="30px"
                                    width="30px"
                                    background="white"
                                    radius="15px">
                                    <H5 line="30px" size="30px" color="green"
                                        hover="green"
                                        cursor="pointer">
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    </H5>
                                </Block>
                            </Flex>
                        }
                        return <Flex onClick={() => NavigateToStep(step.title, step.substeps[0].title)} borderTop="1px solid lightgray"  background="white" padding="10px" justify="space-between" key={`Package-step-icon-${key + 1}`}>
                            <H5 size="14px"  weight="bold">
                                {step.title}
                            </H5>
                            <Flex margin="0"
                                radius="15px"
                                width="30px"
                                height="30px"
                                cursor="pointer"
                                background={(step.title === state.step) ? "#095AC3" : Gray_150}>
                                <P color={(step.title === state.step) ? "white" : "black"}
                                    hover={(step.title === state.step) ? "white" : "black"}
                                    weight="bold">
                                    {key + 1}
                                </P>
                            </Flex>
                        </Flex>
                        
                    })}
                    <Flex onClick={() => NavigateToStep("Review", null)} borderTop="1px solid lightgray" borderBottom="1px solid lightgray" background="white" padding="10px" justify="space-between" key={`Package-step-icon-${data.steps.length + 1}`}>
                        <H5 size="14px" weight="bold">
                            Review
                        </H5>
                        <Flex margin="0"
                            radius="15px"
                            width="30px"
                            height="30px"
                            cursor="pointer"
                            background={(state.step === "Review") ? "#095AC3" : Gray_150}>
                            <P color={(state.step === "Review") ? "white" : "black"}
                                hover={(state.step === "Review") ? "white" : "black"}
                                weight="bold">
                                {data.steps.length + 1}
                            </P>
                        </Flex>
                    </Flex>
                </Fragment>
                : <Fragment>
                    <Block height="2px" top="16px" width="calc(100% - 40px)" left="30px" position="absolute" background={Gray_150} />
                    <Flex justify="space-between">
                        { data && data.steps && data.steps.map((step, key) => {
                            if(CheckStepCompletedStatus(step)) {
                                return <Block width="auto" key={`Package-step-icon-${key + 1}`}>
                                    <Block margin="0 auto"
                                        cursor="pointer"
                                        height="32px"
                                        width="32px"
                                        background="white"
                                        radius="20px">
                                        <H5 line="32px" size="32px" color="green"
                                            hover="green"
                                            cursor="pointer"
                                            onClick={() => NavigateToStep(step.title, step.substeps[0].title)}>
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                        </H5>
                                    </Block>
                                    <H5 size="14px" align="center" margin="10px 0 0 0" weight="bold">
                                        {step.title}
                                    </H5>
                                </Block>
                            }
                            return <Block width="auto" key={`Package-step-icon-${key + 1}`}>
                                <Flex margin="0 auto"
                                    radius="20px"
                                    width="32px"
                                    height="32px"
                                    cursor="pointer"
                                    onClick={() => NavigateToStep(step.title, step.substeps[0].title)}
                                    background={(step.title === state.step) ? "#095AC3" : Gray_150}>
                                    <P color={(step.title === state.step) ? "white" : "black"}
                                        hover={(step.title === state.step) ? "white" : "black"}
                                        weight="bold"
                                        size="16">
                                        {key + 1}
                                    </P>
                                </Flex>
                                <H2 size="14px" align="center" margin="10px 0 0 0" weight="bold">
                                    {step.title}
                                </H2>
                            </Block>
                            
                        })}
                        <Block width="auto" key={`Package-step-icon-${data.steps.length + 1}`}>
                            <Flex margin="0 auto"
                                radius="20px"
                                width="32px"
                                height="32px"
                                cursor="pointer"
                                onClick={() => NavigateToStep("Review", null)}
                                background={(state.step === "Review") ? "#095AC3" : Gray_150}>
                                <P color={(state.step === "Review") ? "white" : "black"}
                                    hover={(state.step === "Review") ? "white" : "black"}
                                    weight="bold"
                                    size="16">
                                    {data.steps.length + 1}
                                </P>
                            </Flex>
                            <H2 size="14px" align="center" margin="10px 0 0 0" weight="bold">
                                Review
                            </H2>
                        </Block>
                    </Flex>
                </Fragment>
            }
            
        </Block>
    )
}
